import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";

import { ApiService } from "./api.service";

@Injectable()
export class AuthGuardService implements CanActivate {
	constructor(private router: Router, private api: ApiService) { }

	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user) {
			return true;
		}

		this.router.navigate(["/login"]);
		return false;
	}
}

@Injectable()
export class AuthGuardOrgAdminService implements CanActivate {
	constructor(private router: Router, private api: ApiService) { }

	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user && (this.api.user.role === "orgadmin" || this.api.user.role === "admin" || this.api.user.role === "master")) {
			return true;
		}

		this.router.navigate(["/dash"]);
		return false;
	}
}

@Injectable()
export class AuthGuardGlobalAdminService implements CanActivate {
	constructor(private router: Router, private api: ApiService) { }

	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user && (this.api.user.role === "admin" || this.api.user.role === "master")) {
			return true;
		}

		this.router.navigate(["/dash"]);
		return false;
	}
}

@Injectable()
export class AuthGuardMasterService implements CanActivate {
	constructor(private router: Router, private api: ApiService) { }

	canActivate() {
		if (!this.api.user) {
			console.log("No user, loading");
			this.api.LoadTokenIfPossible();
		}
		if (this.api.user && this.api.user.role === "master") {
			return true;
		}

		this.router.navigate(["/dash"]);
		return false;
	}
}
